import { useState, useEffect, useMemo } from "react";
import { useSearchParams, useParams } from "react-router-dom";
const useFilters = () => {
  const { categorySlug } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedCategory, setSelectedCategory] = useState(
    categorySlug || null 
  ); 
  const [selectedBrands, setSelectedBrands] = useState([]);
  const selectedColors = searchParams.getAll("color_code[]");
  const [selectedSubCategory, setSelectedSubCategory] = useState(
    searchParams.get("subcategory") || null
  );
  const [priceRange, setPriceRange] = useState(() => {
    const r = searchParams.get("range");
    return r ? r.split(";").map(Number) : [0, 430];
  });
  const [sortBy, setSortBy] = useState(
    searchParams.get("sort_by") || "Relevance"
  );
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  // const per_page = Number(searchParams.get("per_page")) || 10;
  // const page = Number(searchParams.get("page")) || 1;

  useEffect(() => {
  setSearchParams((prev) => {
    const prevParams = Object.fromEntries(prev);

    return {
      ...prevParams,
    ...(selectedBrands.length > 0 && {
  brand: selectedBrands.join(","),
}),
    };
  });
}, [selectedBrands]);
useEffect(() => {
  const brandFromUrl = searchParams.get("brand");

  if (brandFromUrl) {
    setSelectedBrands(brandFromUrl.split(","));
  }
}, []);
  useEffect(() => {
    setSelectedCategory(categorySlug || null);
    setSelectedSubCategory(null);
    setSearchParams((prev) => ({
      ...Object.fromEntries(prev),
      page: "1",
    }));
  }, [categorySlug]);
  useEffect(() => {
    setSearchParams((prev) => {
      const prevParams = Object.fromEntries(prev);
      const nextParams = {
        ...prevParams,
        // page: "1",
        // per_page: per_page.toString(),
        ...(selectedCategory && { category: selectedCategory }),
        ...(selectedSubCategory && { subcategory: selectedSubCategory }),
        ...(priceRange?.length === 2 && {
          range: `${priceRange[0]};${priceRange[1]}`,
        }),
        ...(sortBy !== "Relevance" && { sort_by: sortBy }),
      };
      return nextParams;
    });
  }, [selectedCategory, selectedSubCategory, priceRange, sortBy ,  selectedBrands, ]);
const queryParams = useMemo(
  () => ({
    ...(selectedCategory && { category: selectedCategory }),

    ...(selectedSubCategory && {
      subcategory: selectedSubCategory,
    }),

    ...(priceRange?.length === 2 && {
      range: `${priceRange[0]};${priceRange[1]}`,
    }),

    ...(sortBy !== "Relevance" && {
      sort_by: sortBy,
    }),

    // ✅ BRAND FILTER
    ...(selectedBrands.length > 0 && {
      brand: selectedBrands.join(","),
    }),

    ...(selectedColors.length > 0 && {
      color_code: selectedColors,
    }),
  }),
  [
    selectedCategory,
    selectedSubCategory,
    priceRange,
    sortBy,
    selectedColors,
    selectedBrands,
  ]
);
  const handlePageChange = (newPage) => {
    setSearchParams((prev) => ({
      ...Object.fromEntries(prev),
      page: String(newPage),
    }));
  };
  const handleResetFilters = () => {
    setSelectedSubCategory(null);
    setPriceRange([0, 430]);   
    setSortBy("Relevance");
    // setSearchParams({
    //   page: "1",
    //   per_page: per_page.toString(),
    // });
  };
  return {
    filtersProps: {
      selectedCategory,
      selectedSubCategory,
      priceRange,
      sortBy,
      mobileFiltersOpen,
       selectedBrands,
      // page,
      // per_page,
    },
    filtersActions: {
      setSelectedCategory,
      setSelectedSubCategory,
      setPriceRange,
      setSortBy,
      setMobileFiltersOpen,
      handleResetFilters,
      handlePageChange,
        setSelectedBrands,
    },
    queryParams,
  };
};
export default useFilters;